import React from 'react';
import Icon from './Icon';

export default function OpenGalleryCard({ onClick, className = '' }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`w-full h-[min(192px,_30vh)] ${className}`}
      style={{
        position: 'relative',
        background: '#FFFFFF',
        borderRadius: 20,
        outline: '1px var(--color-accent, #56371F) dashed',
        outlineOffset: '-1px',
      }}
    >
      <div
        style={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          display: 'inline-flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 8,
          width: 105,
        }}
      >
        <span
          aria-hidden
          style={{
            width: 52,
            height: 52,
            background: 'var(--color-accent, #56371F)',
            borderRadius: 100,
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {/* #EFEBE0 = same light cream as nav icons on brown pills */}
          <Icon name="plusWht" size={28} color="#EFEBE0" />
        </span>
        <span
          style={{
            color: 'var(--color-accent, #56371F)',
            fontSize: 16,
            fontFamily: 'Poppins',
            fontWeight: 500,
            whiteSpace: 'nowrap',
          }}
        >
          Open gallery
        </span>
      </div>
    </button>
  );
}


